import { audioManager } from './../objects/AudioManager';
import { FW } from './../framework/Framework';
import { Button, GafButton } from './../framework/display/GafManager';
import { ObjectBase } from './../framework/ObjectBase';

export class BaseScreen extends ObjectBase {


    protected setupButton(clip: PIXI.DisplayObject, callback: () => void, audioType: string): Button {
        if (!clip) {
            return null;
        }

        let button: Button;

        if (clip['totalFrames']) {
            button = new GafButton(clip as GAF.GAFMovieClip);
        } else {
            button = new Button(clip);
        }

        button['delayAudio'] = {};
        button['audioTime'] = 0;

        button.on(GafButton.EVENT.CLICK, () => {
            
            if(button['audio']) {
                button['audio'].stop();
                button['audio'] = null;
            }
            button['audioTime'] = FW.time + 300;
            
            if (callback != null) {
                callback();
            }
        });

        if (audioType) {
            button.on(Button.EVENT.STATE_CHANGE, (state) => {
                button['delayAudio'].disposed = true;
                if (state == Button.EVENT.OVER && FW.time > button['audioTime']) {
                    button['delayAudio'] = FW.addDelayFunction(audioManager, audioManager.playButtonInterface, audioType, 1000);
                }
            });
        }

        return button;
    }

    public playButtonAudio(data: { audioTye: string, button: Button }) {
        audioManager.playButtonInterface(data.audioTye)
            .then(sound => {
                data.button['audio'] = sound;
            });
    }

    public setButtonEnabled(button: Button, enable: boolean, addFilter: boolean = true): void {
        if (!button) {
            return;
        }

        if (enable) {
            button.displayObject.interactive = true;
            button.displayObject.filters = null;
            button.displayObject.alpha = 1;
        } else {
            button['delayAudio'].disposed = true;
            if (addFilter) {
                let filter: PIXI.filters.ColorMatrixFilter = new PIXI.filters.ColorMatrixFilter();
                filter.desaturate();
                button.displayObject.alpha = 0.8;
                button.displayObject.filters = [filter];
            }
            button.displayObject.interactive = false;
        }
    }

    dispose(): void {
        audioManager.stopAll();
        super.dispose();
    }
}


// WEBPACK FOOTER //
// ./src/worlds/BaseScreen.ts